export default "__VITE_ASSET__CKiE02rC__"